import { range } from 'lodash';
import { compose, withPropsOnChange } from 'recompose';
import { withFixedSegmentCategory } from '@sparefoot/react-core/segment';

import { buildSearchLink } from 'utils/search';
import { Pagination } from 'components/core/Pagination';

export const enhance = compose(
	withFixedSegmentCategory('search pagination'),
	withPropsOnChange(['numPages', 'searchParams'], ({ numPages, searchParams }) => ({
		className: 'search-pagination',
		segmentPrefix: 'search pagination',
		pages: range(0, numPages).map((index) => ({
			url: buildSearchLink({ ...searchParams, page: index + 1 }),
			nofollow: false,
			number: index + 1
		}))
	}))
);

export default enhance(Pagination);
